import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { setProfile } from '../../actions/profile';
import { clearError } from '../../actions/findError';

const Login = () => {
  const { loginWithRedirect, isAuthenticated, isLoading, user, error, getAccessTokenSilently } = useAuth0();
  const dispatch = useDispatch();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/dashboard'; // 🧠 sensible default

  console.log('[Login.js] Rendered:', { isLoading, isAuthenticated });
  console.log('[Login.js] Auth0 state:', { isAuthenticated, isLoading, user });

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
     console.log('[Login.js] Not authenticated. Redirecting to Auth0...');
      localStorage.removeItem('profile');
      dispatch(setProfile({ })); // wipe the profile clean
      loginWithRedirect({
        appState: { returnTo: from },
        authorizationParams: {
          redirect_uri: window.location.origin + '/callback',
          audience: process.env.REACT_APP_AUTH0_AUDIENCE, // https://thebrassstargroup.com/iOS
          scope: 'openid profile', // Removed read:reports
        },
      });

    } 
  },[ isAuthenticated, isLoading, dispatch, loginWithRedirect, from]);
  
  useEffect(() => {
   if (isAuthenticated && user && !isLoading) {
      console.log('[Login.js] Authenticated. Dispatching setProfile and clearError...');
      const rawAppMetadata = user['https://thebrassstargroup.com/app_metadata'] || {};
      const rawUserMetadata = user['https://thebrassstargroup.com/user_metadata'] || {};
      dispatch(setProfile({
        email: user.email,
        name: user.name,
        sub: user.sub,
        picture: user.picture,
        nickname: user.nickname,
        app_metadata: rawAppMetadata,
        user_metadata: rawUserMetadata,
      }));

      dispatch(clearError());
    }
  }, [isAuthenticated, isLoading, user, dispatch]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    console.error('[Login.js] Auth0 error:', error);
    return <div>Error: {error.message}</div>;
  }

  if (isAuthenticated) {
    console.log('[Login.js] Redirecting to:', from);
    return <Navigate to={from} replace />;
  }

  return <div>Redirecting to Auth0 login...</div>;
};

export default Login;